import {DevelopmentInProgress} from "../components/table/DevelopmentInProgress";
import {Catalogue} from "../components/catalogue/Catalogue";
import {RoutesPath} from "../enums/RoutesPath";
import {CompareList} from "../components/catalogue/compare/CompareList";
import {CatalogueDetails} from "../components/catalogue/details/CatalogueDetails";
import {Favourites} from "../components/favourites/Favourites";
import {MotoGarages} from "../components/garages/MotoGarages";

export const componentMap: Record<RoutesPath, React.FC> = {
    [RoutesPath.CATALOGUE]: Catalogue,
    [RoutesPath.BUY_MOTORCYCLES]: DevelopmentInProgress,
    [RoutesPath.BUY_PARTS]: DevelopmentInProgress,
    [RoutesPath.REVIEWS]: DevelopmentInProgress,
    [RoutesPath.MOTO_GARAGES]: MotoGarages,
    [RoutesPath.MOTO_GARAGE_DETAILS]: MotoGarages,
    [RoutesPath.CATALOGUE_DETAILS]: CatalogueDetails,
    [RoutesPath.CATALOGUE_COMPARE]: CompareList,
    [RoutesPath.FAVOURITES]: Favourites,
};
